import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IUser } from '../interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private storageKey = 'userProfile';
  private userSubject = new BehaviorSubject<IUser | null>(this.readFromStorage());

  public readonly user$ = this.userSubject.asObservable();

  get snapshot(): IUser | null {
    return this.userSubject.value;
  }

  setUser(user: IUser): void {
    this.userSubject.next(user);
    this.writeToStorage(user);
  }

  clear(): void {
    this.userSubject.next(null);
    localStorage.removeItem(this.storageKey);
  }

  private readFromStorage(): IUser | null {
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as IUser;
    } catch {
      localStorage.removeItem(this.storageKey);
      return null;
    }
  }

  private writeToStorage(user: IUser): void {
    localStorage.setItem(this.storageKey, JSON.stringify(user));
  }
}
